package com.tovtalk.utils.strings

/**
 * Central store for app translations loaded from bundled JSON files.
 * StringProvider reads from here first.
 */
object TranslationsStore {
    private var _translations: Map<String, String> = emptyMap()

    fun get(key: String): String? = _translations[key]

    fun update(translations: Map<String, String>) {
        _translations = translations
    }

    fun clear() {
        _translations = emptyMap()
    }
}
